var _path, _path2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLine = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 271,
  height: 377,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#5CC9E6",
  strokeDasharray: "12 8",
  strokeLinecap: "round",
  strokeOpacity: 0.2,
  strokeWidth: 2,
  d: "M270 329V57c0-30.928-25.072-56-56-56H0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#5CC9E6",
  strokeLinecap: "round",
  strokeWidth: 4,
  d: "M0 56h170c20.987 0 38 17.013 38 38v267"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 208,
  cy: 364,
  r: 13,
  fill: "#5CC9E6"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 208,
  cy: 230,
  r: 10,
  fill: "#5CC9E6"
})));
export default SvgLine;